import { render, staticRenderFns } from "./CaseLogsModal.vue?vue&type=template&id=b5fb2c16&scoped=true"
import script from "./CaseLogsModal.vue?vue&type=script&lang=js"
export * from "./CaseLogsModal.vue?vue&type=script&lang=js"
import style0 from "./CaseLogsModal.vue?vue&type=style&index=0&id=b5fb2c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fb2c16",
  null
  
)

export default component.exports